export const selectMenuProps = {
  disablePortal: true,
  slotProps: {
    paper: {
      sx: {
        maxHeight: 260,
        width: 'auto',
        maxWidth: 440,
        borderRadius: 2,
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
        mt: 0.5,
        '& .MuiAutocomplete-option': {
          typography: 'body2',
          padding: '8px 14px',
          borderRadius: '4px',
          mx: 0.5,
          my: 0.2
        }
      }
    }
  }
};

export const fieldStyles = (minWidth?: number | string) => ({
  minWidth: minWidth || 200,
  '& .MuiOutlinedInput-root': {
    borderRadius: 2,
    height: '40px',
    backgroundColor: 'background.paper',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: 'action.hover',
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'text.secondary'
      }
    },
    '&.Mui-focused': {
      backgroundColor: 'background.paper'
    }
  },
  '& .MuiInputLabel-root': {
    display: 'none'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    legend: { width: 0 }
  }
});
